import { ErrorWidgetAttr } from "../interfaces";

export const ERROR_WIDGET_ATTR: Record<string, ErrorWidgetAttr> = {
    LOCATION_UNSERVICEABLE: {
        title: "Currently not accepting orders",
        message: "This outlet is not available for delivery in your location at the moment.",
        cta: "Retry",
        icon: "NotServiceable_2x_tdaump",
    },

    RESTAURANT_CLOSED: {
        title: "Restaurant is now closed",
        message: "Restaurant is no longer taking new orders.",
        icon: "RClosed_2x_ve3luh",
        cta: "View All Restaurants",
    },

    RESTAURANT_CLOSED_WITH_REOPEN_TODAY: {
        title: "Currently closed for delivery",
        message: "Restaurant will reopen today at sometime",
        cta: "View similar restaurants",
        icon: "RClosed_2x_ve3luh",
    },
    RESTAURANT_CLOSED_WITH_REOPEN_TOMORROW: {
        title: "Currently closed for delivery",
        message: "Restaurant will Reopen tommorrow",
        cta: "View similar restaurants",
        icon: "RClosed_2x_ve3luh",
    },
    RESTAURANT_CLOSED_WITH_REOPEN_SPECIFIC_DAY: {
        title: "Currently closed for delivery",
        message: "Restaurant will reopen in coming days",
        cta: "View similar restaurants",
        icon: "RClosed_2x_ve3luh",
    },
    RESTAURANT_CLOSED_WITH_REOPEN_SPECIFIC_DATE: {
        title: "Currently closed for delivery",
        message: "Restaurant will reopen in coming days",
        cta: "View similar restaurants",
        icon: "RClosed_2x_ve3luh",
    },
    RESTAURANT_CLOSED_WITH_REOPEN_IN_MINUTES: {
        title: "Currently closed for delivery",
        message: "Restaurant will reopen in some minutes",
        cta: "View similar restaurants",
        icon: "RClosed_2x_ve3luh",
    },
    RESTAURANT_CLOSED_WITH_NO_INFO: {
        title: "Currently closed for delivery",
        message: "Restaurant will reopen anytime soon",
        cta: "View similar restaurants",
        icon: "RClosed_2x_ve3luh",
    },
    CITY_CLOSED: {
        title: "Services currently interrupted",
        message: "Delivery services are unavailable in your city at the moment. Please try later.",
        cta: "Go to Home",
        icon: "RClosed_2x_ve3luh",
    },
    ITEM_OUTOFSTOCK: {
        title: "{0} Item(s) unavailable",
        message: "Sorry, few items are out of stock.",
        cta: "Remove Unavailable Items",
        icon: "item-unavilable_xcim1r",
    },

    RESTAURANT_UNSERVICEABLE: {
        title: "Does not deliver to your location",
        message: "This outlet is too far away from your current location",
        icon: "NotServiceable_2x_tdaump",
        cta: "View similar restaurants",
    },

    TOO_MANY_ITEMS: {
        title: "Too many Items!",
        message: "Our delivery personnel cannot carry so many items",
        cta: "Clear Cart",
        icon: "RClosed_2x_ve3luh",
    },
    EXCEEDED_INVENTORY: {
        title: "Too many Items!",
        message: "Some item quantities are more than inventory`",
        cta: "Clear Cart",
        icon: "RClosed_2x_ve3luh",
    },
    PREORDER_SLOT_EXPIRED_CART_ERROR: {
        title: "Your selected time is unavailable",
        message: "Restaurant has switched off online ordering",
        cta: "Choose Slot",
        icon: "RClosed_2x_ve3luh",
    },
    SUPER_SUBSCRIPTION_INVALID: {
        title: "Your Super expired.",
        message: "You had a great run on Super. Get back to the good side.",
        cta: "Remove Super",
        icon: "Super_Logo_Expired_yzylnq",
    },
    MIN_CART_VALUE_ERROR: {
        title: "Oops!! Something went wrong.",
        message: "",
        cta: "Clear Cart",
        icon: "cart_error_icon_ymvz3v",
    },
    EXTERNAL_VALIDATION_FAILED_CART_ERROR: {
        title: "Our systems are acting up",
        message: "Whoops! Something went wrong. Please check later",
        cta: "Clear Cart",
        icon: "cart_error_icon_ymvz3v",
    },

    INCREASE_IN_DEMAND: {
        title: "Currently not accepting orders",
        message: "All nearby delivery partners are currently busy",
        cta: "View similar restaurants",
        icon: "cart_error_icon_ymvz3v",
    },
    RAINS: {
        title: "Currently not accepting orders",
        message: "This outlet is unavailable due to rain in the area",
        cta: "View similar restaurants",
        icon: "cart_error_icon_ymvz3v",
    },
    ZONE_NOT_OPEN: {
        title: "Currently not accepting orders",
        message: "This outlet is not available for delivery in your location at the moment.",
        cta: "View similar restaurants",
        icon: "cart_error_icon_ymvz3v",
    },
    BLACKZONE: {
        title: "Location currently unserviceable",
        message: "Delivery in your location is not available at the moment due to operational issues",
        cta: "Go To Home",
        icon: "cart_error_icon_ymvz3v",
    },
    TOO_MANY_ITEMS_ON_CART: {
        title: "Cart has more items than allowed",
        message:
            "Your cart has more items than what can be safely carried. Please remove a few items or place two orders.",
        cta: "Clear Cart",
        icon: "cart_error_icon_ymvz3v",
    },
    BREAKFAST_SLOT_UNAVAILABLE: {
        title: "No slots available currently.",
        message: "Delivery from this restaurant is not possible in the morning. Please check again later",
        cta: "Go to Home",
        icon: "cart_error_icon_ymvz3v",
    },
    SELECTED_SLOT_UNAVAILABLE: {
        title: "Uh oh! This slot is currently unavailable.",
        message:
            "We have reached maximum limit of orders for this slot. Please select another slot or try again later.",
        cta: "Select Another Slot",
        icon: "cart_error_icon_ymvz3v",
    },
    BULK_ORDER_TOTAL_PRICE_IS_BELOW_THRESHOLD: {
        title: "Your order amount is below ₹2999",
        message: "Please add more items to place a Swiggy Occasions order.",
        cta: "Add more items",
        icon: "cart_error_icon_ymvz3v",
    },
    IRCTC_UNSERVICABLE: {
        title: "Oh no! Time up, you can’t place order for this journey anymore",
        message: "Train orders can be placed only upto 2 hours from the train arrival time",
        cta: "Okay :(",
        icon: "RClosed_2x_ve3luh",
    },
    GIFTING_FOOD_CART_FAILURE: {
        title: "Oops! Something went wrong.",
        message: "Couldn't add items from {0}. Please try again.",
        cta: "Got it!",
        icon: "cart_error_icon_ymvz3v",
    },
    GIFTING_FOOD_CART_POST_ORDER_FAILURE: {
        title: "Shop more to unlock",
        message: "{0}",
        cta: "Add more gifts",
        icon: "cart_error_icon_ymvz3v",
    },
    // Instamart specific error messages
    INSTAMART_ITEM_LEVEL_LIMIT_EXCEEDED: {
        title: "Limited stock available!",
        message: "Reduce qty of below items to proceed.",
        cta: "Reduce Quantity",
        icon: "cart_error_icon_ymvz3v",
        showOverlay: true,
    },
    INSTAMART_TOTAL_ITEM_LIMIT_EXCEEDED: {
        title: "Total item limit exceeded!",
        message: "Please reduce the quantity of gift store item(s) to proceed.",
        cta: "",
        icon: "cart_error_icon_ymvz3v",
    },
    INSTAMART_TOTAL_WEIGHT_LIMIT_EXCEEDED: {
        title: "Total weight limit exceeded!",
        message: "Cart exceeds {0} kg limit. Please remove some items from the gift store to continue.",
        cta: "",
        icon: "cart_error_icon_ymvz3v",
    },
    INSTAMART_TOTAL_VOLUME_LIMIT_EXCEEDED: {
        title: "Total weight limit exceeded!",
        message: "Cart exceeds {0} kg limit. Please remove some items from the gift store to continue.",
        cta: "",
        icon: "cart_error_icon_ymvz3v",
    },
    IM_CART_FAILURE: {
        title: "Oops! Something went wrong.",
        message: "Couldn't add items from Gift store. Please try again.",
        cta: "Got it!",
        icon: "cart_error_icon_ymvz3v",
    },
    DEFAULT: {
        title: "Our systems are acting up",
        message: "Whoops! Something went wrong. Please check later",
        cta: "Clear Cart",
        icon: "cart_error_icon_ymvz3v",
    },
};
